<template>
    <div class="modal fade show add-note-modal" aria-labelledby="addNewCardTitle">
        <div class="modal-dialog modal-dialog-centered modal-xl" ref="admissionModalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center px-1 my-1 align-item-center">
                            <h1 class="mb-0">Treatment Plan</h1>
                            <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0">
                
                <div class="modal-body">
                    <div class="mb-2 col-md-5">
                        <AsyncSelect
                            placeholder="Select Product"
                            v-model="productId"
                            :api-service="fetchProductList"
                            :reduce="name => name.id"
                            :format-label="option => option.text"
                            :additional-query="additionalProductQuery"
                            label="text"
                        />
                    </div>

                    <ItemTable 
                        :table-items="tableItems"
                        @onOpenDentitionModal="onOpenDentitionModal"
                    />

                    <div class="col-12 text-center">
                        <SubmitCancelBtn
                            @onSubmit="submit"
                            @onCancel="closeModal"
                        />
                    </div>
                    
                </div>
            </div>
        </div>

        <AddDentitionModal
            v-if="isOpenDentitionModal"
            v-model:isOpenModal="isOpenDentitionModal"
            :dentition="dentition"
            :dentitionType="dentitionType"
            @onSaveDentition="onSaveDentition"
            :dentitionItem="dentitionItem"
        />
    </div>
</template>

<script setup>
import { onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import ItemTable from "./ItemTable.vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handlePurchase from '@/services/modules/purchase'
import { ref } from "vue";
import handleInventory from "@/services/modules/inventory";
import { computed } from "vue";
import { inject } from "vue";
import SubmitCancelBtn from '@/components/atom/SubmitCancelBtn.vue';
import AddDentitionModal from './AddDentitionModal.vue';

const props = defineProps({
    selectedNotes: {
        type: Array,
        default: []
    },
    dentition: {
        type: Object || null,
        default: () => {}
    },
    dentitionType: {
        type: String || null,
        default: null,
    },
    isOpenModal: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['update:isOpenModal', 'onAddNewTask']);

const {fetchProductList} = handlePurchase();
const store = useStore();
const route = useRoute();
const productId = ref(null);
const tableItems = ref([]);
const { getProduct } = handleInventory();
const showError = inject('showError')
const dentitionItem = ref(null);

const companyId = computed(() => route.params.companyId);
const generalId = computed(() => route.query.general_id ? parseInt(route.query.general_id) : null);

const additionalProductQuery = {
    product_type: "services"
}

const isOpenDentitionModal = ref(false)

const closeModal = () => {
    emit('update:isOpenModal', false);
}

const submit = () => {
    props.selectedNotes.length = 0;
    props.selectedNotes.push(...tableItems.value);
    closeModal();
    emit('onAddNewTask');
}

const onOpenDentitionModal = (item, index) => {
    dentitionItem.value = item;
    isOpenDentitionModal.value = true
}

const onSaveDentition = (selectedDentition) => {
    const tableItem = tableItems.value.find(item => item.product_id === dentitionItem.value.product_id);
    if(! tableItem) return;
    tableItem.dentition = selectedDentition;
}

watch(productId, async () => {
    const found = !!tableItems.value.find(item => item.product_id === productId.value);

    if (found) {
        showError('Item already selected!');
        return;
    }
    
    const productResp = await getProduct({
        id: productId.value,
        company_id: companyId.value
    })

    if (!productResp.data) {
        showError("Something went wrong please try again");
        return;
    }
    let selected = productResp.data;
    let product = {
        name: selected.name
    }
    tableItems.value.push({
        product_id: productId.value,
        name: selected.name,
        description: selected.description.unit.description,
        quantity: 1,
        rate: selected.description.sales_price,
        discount: 0,
        vat: selected.description.vat_rate,
        sub_total: 0,
        discount_amount: 0,
        discount_percent: 0,
        vat_amount: 0,
        total: 0,
        product: product,
        dentition_pertains: [],
        dentition: [],
        schedule_date: null,
        status: null,
        is_default_disabled: false,
        is_edit: false,
    })
})

const setTableItems = () => {
    tableItems.value = props.selectedNotes.map(item => {
        item.isDefaultDisabled = (item.has_prescription || generalId.value === item.id) || false;
        return item;
    });
}

onMounted(() => {
    setTableItems();
})

</script>


<style scoped>
.modal-body{
    min-height: 400px;
}
.card-header {
    padding-top: 0%;
}
.card-header button {
    color: #7367f0;
    padding-left: 12%;
    padding-right: 12%;
    font-weight: bold;
}

.bg {
    background: aliceblue !important;
}
.note-search{
    width: 50%;
}
.med-title{
    padding: 0.486rem 1.5rem;
}
.modal-card{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    max-height: 280px;
    overflow-x: hidden;
    overflow-y: scroll;
}
.add-note-modal {
    display: block; 
    background: #1c1d1c33
}
</style>